import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router";
import { loadConfig } from "./lib/config";
import "./styles.css";
import { AiLog } from "./views/AiLog";
import { Home } from "./views/Home";
import { HostCallback, HostHome, RequireHost } from "./views/Host";
import { HostConsole } from "./views/HostConsole";
import { Join } from "./views/Join";
import { Player } from "./views/Player";

const router = createBrowserRouter([
  { path: "/", element: <Home /> },
  { path: "/host/callback", element: <HostCallback /> },
  {
    path: "/host",
    element: (
      <RequireHost>
        <HostHome />
      </RequireHost>
    ),
  },
  {
    path: "/host/:code",
    element: (
      <RequireHost>
        <HostConsole />
      </RequireHost>
    ),
  },
  { path: "/j/:code", element: <Join /> },
  { path: "/g/:code", element: <Player /> },
  { path: "/g/:code/loki", element: <AiLog /> },
  { path: "*", element: <Home /> },
]);

const queryClient = new QueryClient({ defaultOptions: { queries: { refetchOnWindowFocus: false } } });
if (import.meta.env.DEV) (window as unknown as { __qc: QueryClient }).__qc = queryClient;
const root = createRoot(document.getElementById("root") as HTMLElement);

loadConfig()
  .then(() =>
    root.render(
      <StrictMode>
        <QueryClientProvider client={queryClient}>
          <RouterProvider router={router} />
        </QueryClientProvider>
      </StrictMode>,
    ),
  )
  .catch((e) => {
    root.render(<p style={{ padding: 20 }}>Sovelluksen asetuksia ei saatu ladattua: {String(e)}</p>);
  });
